export default "__VITE_ASSET__BEX$oqTm__"